@if (display(); as display) {
    <ng-container *ngComponentOutlet="display; inputs: inputs()" />
}
